$bog_fragile_demo_collide_child1 $bog_fragile_demo_collide_base1
	sub /
		^
		<= Attach $mol_view
			sub / <= icon \📎
